<template>
 <div class="col-md-3">
   <div class="sidebar__left">
        <div class="sidebar__content">
            <div class="wrapper_search">
                <div class="search_title">
                    Features
                </div>
                <form action="">
            
                    <div class="form-group" v-for="(feature,index) in features" ::key="index" v-if="feature[1]">
                        <input type="checkbox" v-model="check_feature" :value="feature[1]">
                        <label for="checkbox_01">
                            {{feature[1]}}  ({{total_features[index]}}) 
                        </label>
                       
                    </div>
                </form>
                <div class="search_title"  v-if="$store.state.check_empty_rideshares == true">
                    RideShare  
                </div>
                <form> 
                    <div class="form-group" v-for="(feature,index) in features" ::key="index" v-if="feature[2]">
                        <input type="checkbox" v-model="check_rideshare" :value="feature[2]">
                        <label for="checkbox_01">
                            {{feature[2]}} ({{total_rideshares[index]}}) 
                        </label>
                    </div>
                </form>
                <div class="search_title" v-if="$store.state.check_empty_makes == true">
                    Make 
                </div>
                <form> 
                    <div class="form-group" v-for="(feature,index) in features" ::key="index" v-if="feature[3]">
                        <input type="checkbox" v-model="check_make" :value="feature[3]">
                        <label for="checkbox_01">
                            {{feature[3]}} ({{total_makes[index]}})
                        </label>
                    </div>
                </form>
                <div class="search_title" v-if="$store.state.check_empty_models == true">
                    Model 
                </div> 
                <form> 
                    <div class="form-group" v-for="(feature,index) in features" ::key="index" v-if="feature[4]">
                        <input type="checkbox" v-model="check_model" :value="feature[4]">
                        <label for="checkbox_01">
                            {{feature[4]}} ({{total_models[index]}})
                        </label>
                    </div>
                </form>
            </div>
             <div class="wrapper_search search_right" @click="$store.commit('close_sidebar',true)">
             </div>
        </div>
    </div>
</div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    data()
    {
        return {
            check_feature: [],
            check_rideshare: [],
            check_make: [],
            check_model: []
        }
    },
    watch: {
        check_feature(newCheck)
        {
            this.$store.commit("NEXT_PAGE",1)
            this.$store.dispatch('FilterFeature',{
                features: newCheck,
                rideshare: this.check_rideshare,
                makes: this.check_make,
                models: this.check_model
            })
        },
        check_rideshare(rideshare)
        {
            this.$store.commit("NEXT_PAGE",1)
            this.$store.dispatch("FilterFeature",{
                features: this.check_feature,
                rideshare: rideshare,
                makes: this.check_make,
                models: this.check_model
            })
        },
        check_make(makes)
        {
            this.$store.commit("NEXT_PAGE",1)
            this.$store.dispatch("FilterFeature",{
                features: this.check_feature,
                rideshare: this.check_rideshare,
                makes: makes,
                models: this.check_model
            })
        },
        check_model(models)
        {
            this.$store.commit("NEXT_PAGE",1)
            this.$store.dispatch("FilterFeature",{
                features: this.check_feature,
                rideshare: this.check_rideshare,
                makes: this.check_make,
                models: models
            })
        }
    },
    computed: {
        ...mapGetters(["features", "total_features", "total_rideshares", "total_makes", "total_models", "hide_rideshare"])
    },
}
</script>